import { useEffect } from "react"
import useAnalytics from "@mkt/ui/hooks/useAnalytics"

// To Do: duplicated file apps/ccbr/src/pages/Card/components/Content/hook

const useCardContent = ({ content, slug }) => {
  const { form, product } = useAnalytics()
  const name = "card-referral"

  const faq = content?.product_faq
  const productFaq = (faq && faq.length && faq[0]) || false

  useEffect(() => {
    product.setProduct(content)
    form.setForm({
      name,
      type: "soft-lead",
      version: "v1",
      brand: content.issuer,
      id: `iq-${name}`,
    })
  }, [])

  return {
    productFaq,
  }
}

export default useCardContent
